import { getQuantityProducts } from "@/services";
import { useQuery } from "react-query";

export const useGetQuantityProductsData = () => {
 const { data: quantityProducts, isLoading: getQuantityProductsIsLoading } =
  useQuery("quantityProducts", getQuantityProducts);
 return { quantityProducts, getQuantityProductsIsLoading };
};
